export enum Status {
    PENDING,
    NO_QUERY,
    NOT_FOUND,
    FOUND,
    ERROR
}